const csp_nonce = document.querySelector('meta[property=\'csp-nonce\']').getAttribute('content');
__webpack_nonce__ = csp_nonce;